export const enum AppDom {
  auth = 'auth',
  core = 'core',
}
